import { render, staticRenderFns } from "./VipPrice.vue?vue&type=template&id=cb409556&scoped=true"
import script from "./VipPrice.vue?vue&type=script&lang=js"
export * from "./VipPrice.vue?vue&type=script&lang=js"
import style0 from "./VipPrice.vue?vue&type=style&index=0&id=cb409556&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb409556",
  null
  
)

export default component.exports